export default __webpack_public_path__ + "static/media/talent_review_type.82a79ec2.svg";